import { applyCouponDiscount } from '@/entities/reservation'

import { type IProductGroup } from '../model'
import { parsePrice } from './parsePrice'

export const getPlaceMinPrice = (
  productGroups: IProductGroup[]
): number | null => {
  const prices = productGroups
    .map(group => {
      const raw = parsePrice(group.lowestPriceTargetProduct?.salePrice)
      if (raw <= 0) return null
      return applyCouponDiscount(group.section, raw)
    })
    .filter((price): price is number => price !== null)

  if (prices.length === 0) return null

  return Math.min(...prices)
}
